/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injector } from '@angular/core';
import { PoNotificationService } from '@po-ui/ng-components';
import { PoEntity, PoSyncService } from '@po-ui/ng-sync';

import { LiteralsWords } from 'src/app/i18n/literals.model';
import { SchemaFields } from '../interfaces/schema-fields.model';
import { LiteralsService } from './literals-service';
export abstract class BaseResourceService {
  literals: LiteralsWords;

  protected poSync: PoSyncService;
  protected poNotification: PoNotificationService;
  protected literalsService: LiteralsService;

  constructor(
    protected model: string,
    protected injector: Injector,
    protected fieldId: string
  ) {
    this.poSync = injector.get(PoSyncService);
    this.poNotification = injector.get(PoNotificationService);
    this.literalsService = injector.get(LiteralsService);
    this.literals = this.literalsService.getLiteralModule();
  }

  getModel(): PoEntity {
    return this.poSync.getModel(this.model);
  }

  async get(page = 1, filter = {}, pageSize = 10): Promise<any> {
    return await this.getModel()
      .find()
      .sort(this.fieldId)
      .page(page)
      .filter(Object.assign(filter))
      .pageSize(pageSize)
      .exec()
      .then(response => response)
      .catch(error => this.poNotification.error(error));
  }

  async getById(id: string, sort = ''): Promise<any> {
    const filterId = JSON.parse(`{"${this.fieldId}": "${id}"}`);
    return await this.getModel()
      .find()
      .filter(Object.assign(filterId))
      .sort(sort)
      .exec();
  }

  async getByFilterAndSorted(filter, sort = ''): Promise<any> {
    return await this.getModel().find().filter(filter).sort(sort).exec();
  }

  async getFieldsSchemas(schemaEnum: string, namesOfFields: string[] ): Promise<any> {
    return await this.getById(schemaEnum)
      .then(fields =>{
        const schemasFields = [];
        namesOfFields.forEach(nameField =>{
          const field = fields.items.filter(f => f.field === nameField)[0];
          field ? schemasFields.push(field) : undefined;
        });
          return schemasFields;
      })
      .catch(() => this.poNotification.error(this.literals.str0575)); //Falha ao consultar os Schemas
  }

  hasFieldSchema(schemaFields: SchemaFields[], nameOfFields: string): boolean {
    return schemaFields.filter( f => f.field === nameOfFields).length > 0;
  }

  getSchemaPosition(fields: SchemaFields[], nameOfField: string): number {
    return fields.findIndex(f => f.field === nameOfField );
  }

}
